/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ServicedeskReportsSatisfactionType from '@jira/spa-apps__servicedesk-reports-satisfaction/src/SatisfactionViewSpa.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import { SATISFACTION_ROUTE_SUFFIX } from '../../common/constants.tsx';

export const LazyServicedeskReportsSatisfaction: LazyComponent<() => React.JSX.Element> =
	lazyForPaint<typeof ServicedeskReportsSatisfactionType>(() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-servicedesk-reports-satisfaction", jiraSpaEntry: "async-servicedesk-reports-satisfaction" */ '@jira/spa-apps__servicedesk-reports-satisfaction/src/SatisfactionViewSpa.tsx'
			),
		),
	);

const AsyncServicedeskReportsSatisfaction = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskReportsSatisfaction}
		pageId={`spa-apps/servicedesk${SATISFACTION_ROUTE_SUFFIX}}`}
		shouldShowSpinner
	/>
);

export default AsyncServicedeskReportsSatisfaction;
